import { createContext } from 'react';

export interface ICoveoAnalyticsContext {
  apiKey?: string;
  endpoint?: string;
}

const CoveoAnalyticsContext = createContext<ICoveoAnalyticsContext>({
  apiKey: '',
  endpoint: '',
});

export { CoveoAnalyticsContext };
